export const approve = {
  methods: {
    //TODO: 新增审批流程
    async addProcess(obj) {
      const res = await this.$http.post("/tenant/process/config",obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO: 修改审批流程
    async updateProcess(obj) {
      const res = await this.$http.put("/tenant/process/config",obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO：删除审批流程
    async deleteProcess(obj) {
      const res = await this.$http.delete(`/tenant/process/config/${obj.id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO：获取全部审批流程
    async getApproList(){
      let res = await this.$http.get(`/tenant/process/config/list2`);
      return res.data;
    },
    //TODO：获取审批流程配置
    async processList(obj) {
      let { pageSize, pageNum,processName } = obj;
      const res = await this.$http.get("/tenant/process/config/list", {
        processName:processName?? null,
        pageSize,
        pageNum,
      });
      return res;
    },
    //TODO：获取审核流程
    async getMyapprove_audit_process(type) {
      let res = await this.$http.get(`/tenant/process/step/process/${type}`);
      if (res.code == 200) {
        res.data.children.forEach((item) => {
          item.visible = false;
        });
      }

      return res.data;
    },
    // 获取全部用户信息
    async getcustomAll(state = 0) {
      // 默认获取没有被删除的账号信息
      const {
        data: { data },
      } = await this.$http.get("/api/custom_capital_employee/getAll", {
        state,
      });
      return data ? data.list : [];
    },
    // TODO：获取安全检查审核
    async getApproveCheck(obj, approveStatus) {
      let { pageSize, pageNum ,approveNo } = obj;
      const res = await this.$http.get(`/tenant/approve/check/list`, {
        approveStatus: approveStatus == "-1" ? "" : approveStatus,
        approveNo:approveNo,
        pageSize: pageSize,
        pageNum: pageNum,
      });

      return res || [];
    },
    //TODO： 获取隐患整改审核
    async getApproveDangers(obj, approveStatus) {
      let { pageSize, pageNum ,approveNo } = obj;
      const res = await this.$http.get(`/tenant/approve/dangers/list`, {
        approveStatus: approveStatus == "-1" ? "" : approveStatus,
        approveNo:approveNo,
        pageSize: pageSize,
        pageNum: pageNum,
      });

      return res || [];
    },
      //TODO： 获取隐患检查审核
      async getApproveDangersCheck(obj, approveStatus) {
        let { pageSize, pageNum ,approveNo } = obj;
        const res = await this.$http.get(`/tenant/approve/dangers/list2`, {
          approveStatus: approveStatus == "-1" ? "" : approveStatus,
          pageSize: pageSize,
          approveNo:approveNo,
          pageNum: pageNum,
        });
  
        return res || [];
      },
    //TODO： 获取安全风险审核
    async getApproveRisk(obj, approveStatus) {
      let { pageSize, pageNum ,approveNo } = obj;
      const res = await this.$http.get(`/tenant/approve/risk/collect/list`, {
        approveStatus: approveStatus == "-1" ? "" : approveStatus,
        approveNo:approveNo,
        pageSize: pageSize,
        pageNum: pageNum,
      });

      return res || [];
    },
    // 流失类型查询
    async getdictionaryText(id) {
      if (!id) return "";
      const {
        data: { data },
      } = await this.$http.get("/dictionary_content/getByid", { id });
      return data || {};
    },

    // 客户信息查询(id)
    async getCustomInfo(id) {
      const {
        data: { data },
      } = await this.$http.get("/api/custom_capital_info/getByid", { id });
      return data || {};
    },

    // TODO :审批通过
    async approvePast(approveId, reason, approveNo) {
      const res = await this.$http.post("/tenant/approve/pass", {
        approveNo: approveNo ?? null,
        approveId: approveId,
        reason: reason,
      });
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    // TODO : 审批不通过
    async approveunPast(approveId, reason) {
      const res = await this.$http.post("/tenant/approve/not/pass", {
        approveId: approveId,
        reason: reason,
      });
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    // 删除安全检查
    async delApproveun(data) {
      const { data: res } = await this.$http.delete(
        "/api/custom_capital_loss_due_approve/delCustom_capital_loss_due_approve",
        data
      );
      return res?.code === "200" || false;
    },

    // 确认消息
    async MessageBox(text, title = "提示") {
      const res = await this.$confirm(text, title, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch(() => console.log("已取消"));

      return res ? true : false;
    },

    //TODO: 提交审核
    async addsubmitApprove(id) {
      const res = await this.$http.post("/tenant/approve/submit", {
        approveId: id,
      });
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO: 查询审批流程
    async getApprove(id) {
      const res = await this.$http.get("/tenant/approve/history/list", {
        approveId: id,
      });
      return res;
    },

    //TODO: 获取钉钉样式审核流程
    async getOaApproveun(id) {
      const res = await this.$http.get("/tenant/approve/history/list2", {
        approveId: id,
      });
      return res;
    },

    //TODO: 获取生产计划审批列表
    async getOaConstructionApprove(obj, approveStatus) {
      let { pageSize, pageNum ,approveNo ,constructionPlanTime} = obj;
      const res = await this.$http.get(`/tenant/approve/construction/list`, {
        approveStatus: approveStatus == "-1" ? "" : approveStatus,
        constructionPlanTime: constructionPlanTime ?? '',
        approveNo:approveNo,
        pageSize: pageSize,
        pageNum: pageNum,
      });

      return res || [];
    },
  },
};
